// Taşeron portalı — izin sekmesinin tablosu üstündeki "istenen belgeler" kutusu (her satır bunları
// karşılamalıdır). Personel ve Araçlar sekmeleri AYNI kutuyu kullanır; çağıran türlerin entity'sini
// verir, etiket §27 kaydındandır (GL #7; kayıtta yoksa ham kod). Kayıtta olmayan ya da pasif bir tür
// hiçbir zaman karşılanamaz (§27.0(6)) — etiketin yanında bunu söyleyen soluk bir not durur, yükleme
// yolu sunulmaz. Personel sekmesi kutuyu satırların "n / m"siyle AYNI kümeden besler
// (§22 tip + §30.10 izne özel ek talepler, `requestedDocuments`); ek talebin notu türün yanında
// soluk metindir. Not uzmanın serbest metnidir — yalnız metin olarak basılır.
// Tip listesi meta karttaki "Gereksinimler"de de görünür (`PermitDetailPage`) — kart izni özetler,
// bu kutu tabloyu açıklar; tekrar bilinçlidir (#12).

import { Tag, useDocumentTypes } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';

export interface RequiredDocumentItem {
  /** Belge türü — `entity`'nin §27 kayıt kodu (PascalCase wire). */
  documentType: string;
  /** İzne özel ek talebin notu (§30.10); tip-standart belgede `null`. */
  note: string | null;
}

interface RequiredDocumentsListProps {
  heading: string;
  emptyText: string;
  /** İstenen türler, sunucu sırasında; tür başına tek öğe. */
  documents: readonly RequiredDocumentItem[];
  /** Türlerin entity'si (§22 gereksinimleri yalnız personel/araç taşır). */
  entity: 'personnel' | 'vehicle';
}

export function RequiredDocumentsList({
  heading,
  emptyText,
  documents,
  entity,
}: RequiredDocumentsListProps) {
  const { t } = useTranslation();
  const { label, inactiveOrUnknown } = useDocumentTypes();
  return (
    <div className="flex flex-col gap-2 border-b border-border px-4 py-3">
      <h3 className="text-xs text-muted">{heading}</h3>
      {documents.length === 0 ? (
        <p className="text-sm text-muted">{emptyText}</p>
      ) : (
        <ul className="flex flex-wrap gap-1.5">
          {documents.map((doc) => (
            <li
              key={doc.documentType}
              className="flex min-w-0 max-w-full flex-wrap items-baseline gap-x-1.5 gap-y-0.5"
            >
              <Tag color="gray" wrap>
                {label(entity, doc.documentType)}
              </Tag>
              {doc.note ? (
                <span className="min-w-0 break-words text-xs text-muted">{doc.note}</span>
              ) : null}
              {inactiveOrUnknown(entity, doc.documentType) ? (
                <span className="shrink-0 text-xs text-muted">
                  {t('documentTypes.inactiveSuffix')}
                </span>
              ) : null}
            </li>
          ))}
        </ul>
      )}
      {documents.some((doc) => inactiveOrUnknown(entity, doc.documentType)) ? (
        <p className="text-xs text-muted">{t('documentTypes.inactiveMissing')}</p>
      ) : null}
    </div>
  );
}
